import { Injectable } from '@angular/core';
// import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';


@Injectable()
export class TokenService {
  currentUser;
  // currentUserChange: BehaviorSubject<any> = new BehaviorSubject<any>(this.currentUser);
  currentUserChange: Subject<any> = new Subject<any>();

  getToken(): any {
    if (this.currentUser) {
      return this.currentUser;
    } else {
      this.currentUser = JSON.parse(window.localStorage.getItem('shUserInfo'));
      this.currentUserChange.next(this.currentUser);
      return this.currentUser;
    }
  }

  saveToken(user: any) {
    this.currentUser = user;
    this.currentUserChange.next(this.currentUser);
    window.localStorage.setItem('shUserInfo', JSON.stringify(user));
  }

  destroyToken() {
    this.currentUser = null;
    this.currentUserChange.next(this.currentUser);
    window.localStorage.removeItem('shUserInfo');
  }
}



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/services/token.service.ts